"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildRoleRefined = void 0;
const buildRoleRefined = (roleProperties, users) => ({
    ID: roleProperties.ID,
    description: roleProperties.description,
    name: roleProperties.name,
    status: roleProperties.status,
    mandatory: roleProperties.mandatory,
    permissions: roleProperties.permissions.values,
    customAttributes: roleProperties.customAttributes,
    institutionIdentifier: roleProperties.institutionIdentifier,
    metadata: {
        created: roleProperties.metadata.created,
        updated: roleProperties.metadata.updated,
    },
    users: users.map((user) => ({
        ID: user.user.ID,
        firstName: user.user.firstName,
        lastName: user.user.lastName,
        emailAddress: user.user.emailAddress,
        status: user.user.status,
        accountType: user.user.accountType,
        lastLogin: user.user.lastLogin,
        accessIDs: user.accessApplied.values,
        assigned: user.assigned,
    })),
});
exports.buildRoleRefined = buildRoleRefined;
//# sourceMappingURL=RoleRefined.js.map